export const TranslationKeys = {
    name: "name",
    localeLanguage: "localeLanguage",
    zone: "zone",
    entryReader: "entryReader",
    exitReader: "exitReader",
    building: "building",
    interLeadingZone: "interLeadingZone",
    floor: "floor",
    multiTag: "multiTag",
    settings: "settings",
    readers: "readers",
    ioDevices: "ioDevices",
    notes: "notes",
    hardware: "hardware",
    doors: "doors",
    accessArea: "accessArea",
    description: "description",
    deviceTimePattern: "deviceTimePattern",
    startDate: "startDate",
    endDate: "endDate",
    startTime: "startTime",
    endTime: "endTime",
    site: "site",
    daysOfTheWeek: "daysOfTheWeek",
    details: "details",
    accessAreas: "accessAreas",
    enrolments: "enrolments",
    sites: "sites",
    configuration: "configuration",
    holidays: "holidays",
    messages: "messages",
    message: "message",
    hostIP: "hostIP",
    wanIP: "wanIP",
    timeZone: "timeZone",
    tagmask: "tagmask",
    tagmaskRemovezeros: "tagmaskRemovezeros",
    assignedSiteCodes: "assignedSiteCodes",
    assignedGroups: "assignedGroups",
    siteCodes: "siteCodes",
    liftOrElevators: "liftOrElevators",
    tagPresentation: "tagPresentation",
    inputActivation: "inputActivation",
    relayDurations: "relayDurations",
    defaultReplayContactState: "defaultReplayContactState",
    normallyClosed: "normallyClosed",
    normallyOpen: "normallyOpen",
    assignedZones: "assignedZones",
    commonZones: "commonZones",
    zones: "zones",
    add: "add",
    floors: "floors",
    assignedFloors: "assignedFloors",
    assignedTimeTriggeredActions: "assignedTimeTriggeredActions",
    assignTimeTriggeredActions: "assignTimeTriggeredActions",
    submit: "submit",
    filters: "filters",
    manage: "manage",
    assignZones: "assignZones",
    assignAccessGroups: "assignAccessGroups",
    personnel: "personnel",
    credentials: "credentials",
    access: "access",
    accessType: "accessType",
    relationships: "relationships",
    displayName: "displayName",
    uniqueIdentifier: "uniqueIdentifier",
    email: "email",
    pinNumber: "pinNumber",
    enableCredentials: "enableCredentials",
    apbOverride: "apbOverride",
    male: "male",
    female: "female",
    unspecified: "unspecified",
    title: "title",
    firstName: "firstName",
    secondName: "secondName",
    lastName: "lastName",
    suffix: "suffix",
    gender: "gender",
    printTemplate: "printTemplate",
    timeAndAttendance: "timeAndAttendance",
    employment: "employment",
    company: "company",
    department: "department",
    enrol: "enrol",
    assignedCredentials: "assignedCredentials",
    assignedRelationships: "assignedRelationships",
    assignRelationships: "assignRelationships",
    cardFormats: "cardFormats",
    manageAccessGroups: "manageAccessGroups",
    accessGroups: "accessGroups",
    masterAccessGroups: "masterAccessGroups",
    masterFloors: "masterFloors",
    info: "info",
    error: "error",
    warning: "warning",
    success: "success",
    credentialSaved: "credentialSaved",
    buildingSaved: "buildingSaved",
    holidaySaved: "holidaySaved",
    messageSaved: "messageSaved",
    siteSaved: "siteSaved",
    accessAreaSaved: "accessAreaSaved",
    accessGroupSaved: "accessGroupSaved",
    accessTimePatternSaved: "accessTimePatternSaved",
    companySaved: "companySaved",
    departmentSaved: "departmentSaved",
    enrolmentSaved: "enrolmentSaved",
    commonZoneSaved: "commonZoneSaved",
    deviceTimePatternSaved: "deviceTimePatternSaved",
    doorSaved: "doorSaved",
    reasonCodeSaved: "reasonCodeSaved",
    zoneSaved: "zoneSaved",
    applicationError: "applicationError",
    missingEnrolment: "missingEnrolment",
    accounts: "accounts",
    security: "security",
    operators: "operators",
    logins: "logins",
    newSiteCode: "newSiteCode",
    save: "save",
    cancel: "cancel",
    events: "events",
    actions: "actions",
    parameters: "parameters",
    masterController: "masterController",
    ipAddress: "ipAddress",
    fixedAddress: "fixedAddress",
    preset: "preset",
    type: "type",
    masterControllers: "masterControllers",
    biometrics: "biometrics",
    modulesAndIO: "modulesAndIO",
    doorControllers: "doorControllers",
    tagCode: "tagCode",
    status: "status",
    back: "back",
    next: "next",
    expiryDate: "expiryDate",
    expiryTime: "expiryTime",
    confirm: "confirm",
    taskDetails: "taskDetails",
    task: "task",
    procedure: "procedure",
    assignedParameters: "assignedParameters",
    assignedActions: "assignedActions",
    assignActions: "assignActions",
    enrollCredential: "enrollCredential",
    tasks: "tasks",
    enrolCard: "enrolCard",
    taskProcedure: "taskProcedure",
    summary: "summary",
    pending: "pending",
    enterDetails: "enterDetails",
    assignedEvents: "assignedEvents",
    network: "network",
    logicalAddress: "logicalAddress",
    enabled: "enabled",
    disabled: "disabled",
    diagnosticReportingTime: "diagnosticReportingTime",
    version: "version",
    macAddress: "macAddress",
    controllerSaved: "controllerSaved",
    companies: "companies",
    defaultMode: "defaultMode",
    function: "function",
    biometricInput: "biometricInput",
    threatLevel: "threatLevel",
    position: "position",
    input: "input",
    readerSaved: "readerSaved",
    copyOf: "copyOf",
    behavior: "behavior",
    inputs: "inputs",
    advanced: "advanced",
    readerPreset: "readerPreset",
    readerPresetSaved: "readerPresetSaved",
    controllerPreset: "controllerPreset",
    moduleAndIOPresets: "moduleAndIOPresets",
    allReaders: "allReaders",
    departments: "departments",
    accessTimePatterns: "accessTimePatterns",
    deviceTimePatterns: "deviceTimePatterns",
    controllers: "controllers",
    controllerPresetSaved: "controllerPresetSaved",
    assignedInputs: "assignedInputs",
    ioDevicePresetSaved: "ioDevicePresetSaved",
    referenceError: "referenceError",
    deleteSuccess: "deleteSuccess",
    unsupportedImage: "unsupportedImage",
    hostname: "hostname",
    wanIpAddress: "wanIpAddress",
    staticIpAddress: "staticIpAddress",
    subnetMask: "subnetMask",
    secureMode: "secureMode",
    gateway: "gateway",
    forceChanges: "forceChanges",
    updateType: "updateType",
    incomingPortFromEngine: "incomingPortFromEngine",
    incomingPortFromDC: "incomingPortFromDC",
    outgoingPortFromEngine: "outgoingPortFromEngine",
    ports: "ports",
    unsavedChanges: "unsavedChanges",
    unsavedChangesMessage: "unsavedChangesMessage",
    dontSave: "dontSave",
    secureModeMessage: "secureModeMessage",
    enable: "enable",
    enableSecureMode: "enableSecureMode",
    updateDeviceOnly: "updateDeviceOnly",
    updateDeviceAndCommsChannel: "updateDeviceAndCommsChannel",
    allController: "allController",
    allModulesAndIO: "allModulesAndIO",
    assignedControllers: "assignedControllers",
    assignControllers: "assignControllers",
    assignedReaders: "assignedReaders",
    assignReaders: "assignReaders",
    level: "level",
    assignFloor: "assignFloor",
    floorSaved: "floorSaved",
    ioModules: "ioModules",
    cardTypes: "cardTypes",
    cards: "cards",
    cardFormat: "cardFormat",
    assign: "assign",
    linkToEvent: "linkToEvent",
    cardFormatSaved: "cardFormatSaved",
    assignedTypes: "assignedTypes",
    siteMask: "siteMask",
    cardTagMask: "cardTagMask",
    cardTagMaskRemoveZeros: "cardTagMaskRemoveZeros",
    timeTriggeredAction: "timeTriggeredAction",
    timeTriggeredActions: "timeTriggeredActions",
    deviceAction: "deviceAction",
    timeTriggeredActionSaved: "timeTriggeredActionSaved",
    actionToExecute: "actionToExecute",
    activePeriod: "activePeriod",
    eventActionsUpdated: "eventActionsUpdated",
    assignDeviceActions: "assignDeviceActions",
    cardTypesUpdated: "cardTypesUpdated",
    assignCardTypes: "assignCardTypes",
    engine: "engine",
    syncDevices: "syncDevices",
    installMasterController: "installMasterController",
    noContent: "noContent",
    scanSubnet: "scanSubnet",
    scanBus: "scanBus",
    selectADeviceToInstall: "selectADeviceToInstall",
    doorCreation: "doorCreation",
    entryReaderOnly: "entryReaderOnly",
    exitAndEntryReaders: "exitAndEntryReaders",
    automaticallyCreateNewDoor: "automaticallyCreateNewDoor",
    selectedDevice: "selectedDevice",
    autoCreateDoors: "autoCreateDoors",
    notApplicable: "notApplicable",
    execute: "execute",
    selectDevice: "selectDevice",
    device: "device",
    categories: "categories",
    elevators: "elevators",
    signIn: "signIn",
    password: "password",
    username: "username",
    login: "login",
    permissions: "permissions",
    reasonCodes: "reasonCodes",
    tourRoutes: "tourRoutes",
    assignedEntryActions: "assignedEntryActions",
    assignedExitActions: "assignedExitActions",
    assignEntryActions: "assignEntryActions",
    assignExitActions: "assignExitActions",
    entryActionsUpdated: "entryActionsUpdated",
    exitActionsUpdated: "exitActionsUpdated",
    entryActions: "entryActions",
    exitActions: "exitActions",
    members: "members",
    assignedMembers: "assignedMembers",
    assignMembers: "assignMembers",
    all: "all",
    allEnrolments: "allEnrolments",
    notSavedYet: "notSavedYet",
    modules: "modules",
    scheduledTours: "scheduledTours",
    activeTours: "activeTours",
    routes: "routes",
    notifications: "notifications",
    addWidget: "addWidget",
    quickEnrol: "quickEnrol",
    widget: "widget",
    addAWidget: "addAWidget",
    selectAWidget: "selectAWidget",
    widgetType: "widgetType",
    chooseRouteLink: "chooseRouteLink",
    general: "general",
    monitoring: "monitoring",
    dashboard: "dashboard",
    edit: "edit",
    suspendedGroup: "suspendedGroup",
    accessTimePattern: "accessTimePattern",
    remainingCharacters: "remainingCharacters",
    eventTypes: "eventTypes",
    days: "days",
    duration: "duration",
    code: "code",
    usedBy: "usedBy",
    inputOrPortNo: "inputOrPortNo",
    accessGroup: "accessGroup",
    workNumber: "workNumber",
    mobile: "mobile",
    stidMobile: "stidMobile",
    hidMobileAccess: "hidMobileAccess",
    dateLinked: "dateLinked",
    durationWarning: "durationWarning",
    slot: "slot",
    timePattern: "timePattern",
    actionType: "actionType",
    actionName: "actionName",
    antiPassback: "antiPassback",
    category: "category",
    middleName: "middleName",
    queue: "queue",
    pdf: "pdf",
    excel: "excel",
    transactions: "transactions",
    transaction: "transaction",
    alarms: "alarms",
    audit: "audit",
    timebased: "timebased",
    realtime: "realtime",
    reports: "reports",
    privileges: "privileges",
    milestoneVMS: "milestoneVMS",
    virtualIO: "virtualIO",
    cctv: "cctv",
    floorPlans: "floorPlans",
    presets: "presets",
    buildings: "buildings",
    saveFailedCheckRequiredFields: "saveFailedCheckRequiredFields",
    editActionPreset: "editActionPreset",
    newActionPreset: "newActionPreset",
    editInputPreset: "editInputPreset",
    newInputPreset: "newInputPreset",
    editParameterPreset: "editParameterPreset",
    newParameterPreset: "newParameterPreset",
    autoSync: "autoSync",
    noCardFoundOnTheDevice: "noCardFoundOnTheDevice",
    notSupportedForNow: "notSupportedForNow",
    failedToRemoveReader: "failedToRemoveReader",
    readerRemoved: "readerRemoved",
    addNew: "addNew",
    noRecordsfound: "noRecordsfound",
    searchEnrolmentByCard: "searchEnrolmentByCard",
    enrolmentDevice: "enrolmentDevice",
    singleOwner: "singleOwner",
    autoGenerateIdNumber: "autoGenerateIdNumber",
    addField: "addField",
    fields: "fields",
    scan: "scan",
    categorySaved: "categorySaved",
    readingCardError: "readingCardError",
    pluginError: "pluginProblem",
    dateTime: "dateTime",
    event: "event",
    reader: "reader",
    transactionType: "transactionType",
    today: "today",
    serialAddress: "serialAddress",
    organizationId: "organizationId",
    userId: "userId",
    credentialsAvailable: "credentialsAvailable",
    partNumber: "partNumber",
    query: "query",
    swap: "swap",
    swapReadersAround: "swapReadersAround",
    openDoor: "openDoor",
    doorOpened: "doorOpened",
    cantOpenDoorMessage: "cantOpenDoorMessage",
    mobileAccessSummaryMessage: "mobileAccessSummaryMessage",
    mobileStidSummaryMessage: "mobileStidSummaryMessage",
    updateUserEmailFail: "updateUserEmailFail",
    source: "source",
    allTransactions: "allTransactions",
    credential: "credential",
    credentialHolder: "credentialHolder",
    showing: "showing",
    of: "of",
    liveTransactionError: "liveTransactionError",
    engineConnError: "engineConnError",
    noPartsFound: "noPartsFound",
    accountSaved: "accountSaved",
    card: "card",
    play: "play",
    pause: "pause",
    uploadProfileImage: "uploadProfileImage",
    uploaded: "uploaded",
    dragAndDropDialogText: "dragAndDropDialogText",
    allAllowed: "allAllowed",
    allDenied: "allDenied",
    denied: "denied",
    alarm: "alarm",
    holiday: "holiday",
    siteCodeSaved: "siteCodeSaved",
    featureUnderConstruction: "featureUnderConstruction",
    notAvailable: "notAvailable",
    widgetSelectionMessage: "widgetSelectionMessage",
    loginSaved: "loginSaved",
    savingError: "savingError",
    permanentlyDeleteRecord: "permanentlyDeleteRecord",
    deleteRecord: "deleteRecord",
    deleteRecordWithName: "deleteRecordWithName",
    partialSuccessFldSave: "partialSuccessFldSave",
    failedToExecuteEmergencyMode: "failedToExecuteEmergencyMode",
    failedToExecuteLockdownMode: "failedToExecuteLockdownMode",
    failedToExecuteOpenDoor: "failedToExecuteOpenDoor",
    failedToExecuteResetApb: "failedToExecuteResetApb",
    partialSuccess: "partialSuccess",
    urlCopySuccess: "urlCopySuccess",
    apiDebugger: "apiDebugger",
    urlEndpointTableHeader: "urlEndpointTableHeader",
    responsesTableHeader: "responsesTableHeader",
    clear: "clear",
    close: "close",
    editMyProfile: "editMyProfile",
    controls: "controls",
    myHoursWorked: "myHoursWorked",
    myNotifications: "myNotifications",
    signOut: "signOut",
    noAvailableOptions: "noAvailableOptions",
    selectDate: "selectDate",
    selectTime: "selectTime",
    checkboxListField: "checkboxListField",
    applyQuickFilter: "applyQuickFilter",
    filterModalSetupOne: "filterModalSetupOne",
    searchFilter: "searchFilter",
    searchBy: "searchBy",
    selectedFilterValueDefault: "selectedFilterValueDefault",
    selectedFilterDefault: "selectedFilterDefault",
    confirmPassword: "confirmPassword",
    changePassword: "changePassword",
    oldPassword: "oldPassword",
    newPassword: "newPassword",
    character: "character",
    ok: "ok",
    notSpecified: "notSpecified",
    systemController: "systemController",
    relaxedTimeExit: "relaxedTimeExit",
    entryLockoutDelay: "entryLockoutDelay",
    exitLockoutDelay: "exitLockoutDelay",
    maxCapacity: "maxCapacity",
    helloButton: "helloButton",
    charactersNotAllowed: "charactersNotAllowed",
    required: "required",
    minimumValueWithMinimumValue: "minimumValueWithMinimumValue",
    maximimumValueWithMaximumValue: "maximimumValueWithMaximumValue",
    beforeStartDate: "beforeStartDate",
    dateRangeExceedsOneMonth: "dateRangeExceedsOneMonth",
    dateRangeExceedsOneWeek: "dateRangeExceedsOneWeek",
    beforeStartTime: "beforeStartTime",
    timesCantBeEqual: "timesCantBeEqual",
    notValidEmail: "notValidEmail",
    passwordNotMatched: "passwordNotMatched",
    passwordDoNotMatch: "passwordDoNotMatch",
    passwordLengthValidation: "passwordLengthValidation",
    passwordVariableLengthValidation: "passwordVariableLengthValidation",
    passwordRegexValidation: "passwordRegexValidation",
    passwordWhitespaceValidation: "passwordWhitespaceValidation",
    accessGroupCapacity: "accessGroupCapacity",
    serverError: "serverError",
    readServerResponseFailed: "readServerResponseFailed",
    itemsNotSavedCorrectly: "itemsNotSavedCorrectly",
    serverUnresponsiveMessage: "serverUnresponsiveMessage",
    cannotFetchData: "cannotFetchData",
    cannotDeserializeResponse: "cannotDeserializeResponse",
    someContent: "someContent",
    cardBody: "cardBody",
    cardHeader: "cardHeader",
    cardFooter: "cardFooter",
    closingView: "closingView",
    enrolMobile: "enrolMobile",
    reset: "reset",
    selectOrderColumns: "selectOrderColumns",
    hexValuesOnly: "hexValuesOnly",
    numbersOnly: "numbersOnly",
    aboutUs: "aboutUs",
    termsAndConditions: "termsAndConditions",
    helpTopics: "helpTopics",
    setup: "setup",
    describeCategory: "describeCategory",
    selectApplicableFields: "selectApplicableFields",
    newCategory: "newCategory",
    searchFieldPlaceholder: "searchFieldPlaceholder",
    professional: "professional",
    columns: "columns",
    done: "done",
    more: "more",
    now: "now",
    remainingCharactersWithCharacterCount: "remainingCharactersWithCharacterCount",
    sunday: "sunday",
    monday: "monday",
    tuesday: "tuesday",
    wednesday: "wednesday",
    thursday: "thursday",
    friday: "friday",
    saturday: "saturday",
    january: "january",
    february: "february",
    march: "march",
    april: "april",
    may: "may",
    june: "june",
    july: "july",
    august: "august",
    september: "september",
    october: "october",
    november: "november",
    december: "december",
    get: "get",
    showListOf: "showListOf",
    list: "list",
    discoveryMessage: "discoveryMessage",
    controllerInstallFailure: "controllerInstallFailure",
    found: "found",
    installed: "installed",
    completed: "completed",
    updatingHardwareSettings: "updatingHardwareSettings",
    unstallingMessage: "unstallingMessage",
    saveInProgress: "saveInProgress",
    deleteInProgress: "deleteInProgress",
    imageSaved: "imageSaved",
    siteCodeSavedSuccessfully: "siteCodeSavedSuccessfully",
    inputCharacterLengthWithLength: "inputCharacterLengthWithLength",
    howTo: "howTo",
    engineStarted: "engineStarted",
    engineStopped: "engineStopped",
    enrolment: "enrolment",
    titleWithTitle: "titleWithTitle",
    descriptionWithDescription: "descriptionWithDescription",
    userWithUser: "userWithUser",
    dateWithDate: "dateWithDate",
    rowCountWithRowCount: "rowCountWithRowCount",
    appliedFilters: "appliedFilters",
    totalPersonnelOnSiteWithValue: "totalPersonnelOnSiteWithValue",
    totalPersonnelMusteredWithValue: "totalPersonnelMusteredWithValue",
    totalPersonnelUnaccountedForWithValue: "totalPersonnelUnaccountedForWithValue",
    appliedSearchTermAndHeadingWithAppliedSearchTermAndHeading: "appliedSearchTermAndHeadingWithAppliedSearchTermAndHeading",
    processing: "processing",
    installConnectionError: "installConnectionError",
    assignedModules: "assignedModules",
    assignModules: "assignModules",
    presetSaved: "presetSaved",
    ioModuleSaved: "ioModuleSaved",
    copyright: "copyright",
    license: "license",
    about: "about",
    production: "production",
    licensedFor: "licensedFor",
    softwareLicense: "softwareLicense",
    copyrightAllRightsReserved: "copyrightAllRightsReserved",
    servicePack: "servicePack",
    alpha: "alpha",
    beta: "beta",
    editCategory: "editCategory",
    createdBy: "createdBy",
    allReports: "allReports",
    reportSaved: "reportSaved",
    report: "report",
    location: "location",
    address: "address",
    deviceDescription: "deviceDescription",
    door: "door",
    doorDescription: "doorDescription",
    expired: "expired",
    direction: "direction",
    deviceType: "deviceType",
    reasonCode: "reasonCode",
    deleteCategory: "deleteCategory",
    relatedEnrolments: "relatedEnrolments",
    group: "group",
    describeThisField: "describeThisField",
    describeThisGroup: "describeThisGroup",
    fieldSaved: "fieldSaved",
    fieldName: "fieldName",
    fieldType: "fieldType",
    toolTip: "toolTip",
    customField: "customField",
    selectGroup: "selectGroup",
    createGroup: "createGroup",
    groupType: "groupType",
    newGroupName: "newGroupName",
    fieldDeleted: "fieldDeleted",
    entry: "entry",
    exit: "exit",
    yes: "yes",
    no: "no",
    date: "date",
    time: "time",
    firstInLastOut: "firstInLastOut",
    day: "day",
    cardExpiry: "cardExpiry",
    hardwareInstallion: "hardwareInstallion",
    absenteeism: "absenteeism",
    refresh: "refresh",
    refreshInProgress: "refreshInProgress",
    firstInReport: "firstInReport",
    lastOutReport: "lastOutReport",
    port: "port",
    controller: "controller",
    biometricPresets: "biometricPresets",
    biometricDevices: "biometricDevices",
    assignBiometricDevices: "assignBiometricDevices",
    assignedBiometricDevices: "assignedBiometricDevices",
    allBiometricPresets: "allBiometricPresets",
    onlyIntegersAllowed: "onlyIntegersAllowed",
    presetInputModules: "presetInputModules",
    presetActionModules: "presetActionModules",
    system: "system",
    recordUpdated: "recordUpdated",
    syncAll: "syncAll",
    syncSelectedOnly: "syncSelectedOnly",
    syncIdemiaOnly: "syncIdemiaOnly",
    syncControlId: "syncControlId",
    syncHikVision: "syncHikVision",
    syncHidAmico: "syncHIDAmico",
    pleaseSelectBiometricDevice: "pleaseSelectBiometricDevice",
    syncInProgress: "syncInProgress",
    installBiometric: "installBiometric",
    selectDeviceType: "selectDeviceType",
    startIp: "startIp",
    endIp: "endIp",
    ipAddressValidation: "ipAddressValidation",
    enterSearchDetails: "enterSearchDetails",
    scanFilters: "scanFilters",
    serial: "serial",
    ip: "ip",
    model: "model",
    scanning: "scanning",
    zeroDevicesFound: "zeroDevicesFound",
    biometricPresetSaved: "biometricPresetSaved",
    install: "install",
    serialNumber: "serialNumber",
    wiegand: "wiegand",
    osdp: "OSDP",
    communications: "communications",
    off: "off",
    low: "low",
    elevated: "elevated",
    high: "high",
    importLicense: "importLicense",
    exportLicense: "exportLicense",
    unsupportedFileType: "unsupportedFileType",
    licenseImportedSuccessfully: "licenseImportedSuccessfully",
    tagType: "tagType",
    finger: "finger",
    deviceNotFound: "deviceNotFound",
    leftLittle: "leftLittle",
    leftRing: "leftRing",
    leftMiddle: "leftMiddle",
    leftIndex: "leftIndex",
    leftThumb: "leftThumb",
    rightThumb: "rightThumb",
    rightIndex: "rightIndex",
    rightMiddle: "rightMiddle",
    rightRing: "rightRing",
    rightLittle: "rightLittle",
    chooseDevice: "chooseDevice",
    chooseFinger: "chooseFinger",
    chooseCard: "chooseCard",
    selectACardToAssociateTheTemplateWith: "selectACardToAssociateTheTemplateWith",
    morphoEnrollType: "morphoEnrollType",
    single: "single",
    mso300: "mso300",
    selectAFingerToEnroll: "selectAFingerToEnroll",
    truncationFormat: "truncationFormat",
    facilityCode: "facilityCode",
    credentialIdentifier: "credentialIdentifier",
    credentialNumber: "credentialNumber",
    userValidation: "userValidation",
    usersReaderVsDB: "usersReaderVsDB",
    commands: "commands",
    disable: "disable",
    commandExecuted: "commandExecuted",
    pluginManagerError: "pluginManagerError",
    enrolType: "enrolType",
    leftHand: "leftHand",
    rightHand: "rightHand",
    both: "both",
    noEnrolmentDeviceFound: "noEnrolmentDeviceFound",
    selectEnrolmentType: "selectEnrolmentType",
    enrolmentDetails: "enrolmentDetails",
    loadingDevices: "loadingDevices",
    availableSystemDeviceFailure: "availableSystemDeviceFailure",
    enrolFinger: "enrolFinger",
    enrolHand: "enrolHand",
    enrolFace: "enrolFace",
    manualEnterCodeType: "manualEnterCodeType",
    personalAccessCode: "personalAccessCode",
    manualEnterHidCredential: "manualEnterHidCredential",
    randomPAC: "randomPAC",
    enrolViaMDE: "enrolViaMDE",
    enrolViaHIDFargoPronter: "enrolViaHIDFargoPronter",
    enrolViaMASigmaWave: "enrolViaMASigmaWave",
    enrolViaMSO300: "enrolViaMSO300",
    enrolViaIdBio: "enrolViaIdBio",
    enrolViaNitgen: "enrolViaNitgen",
    enrolViaSuprema: "enrolViaSuprema",
    enrolViaHIDRB25B: "enrolViaHIDRB25B",
    enrolViaIdemiaFinger: "enrolViaIdemiaFinger",
    enrolViaLumidigmM211: "enrolViaLumidigmM211",
    enrolViaHIKVision: "enrolViaHIKVision",
    enrolViaHikCamera: "enrolViaHikCamera",
    enrolViaSupremaFace: "enrolViaSupremaFace",
    enrolViaIBR: "enrolViaIBR",
    enrolViaHIDR25F: "enrolViaHIDR25F",
    enrolViaOmnikey: "enrolViaOmnikey",
    enrolViaControlId: "enrolViaControlId",
    enrolViaControlIdCamera: "enrolViaControlIdCamera",
    enrolViaHIDCamera: "enrolViaHIDCamera",
    extensionEnroll: "extensionEnroll",
    userValidatioWarning: "userValidatioWarning",
    enableDevice: "enableDevice",
    disableDevice: "disableDevice",
    enableDisableDeviceMessage: "enableDisableDeviceMessage",
    fullyNestedWithinZone: "fullyNestedWithinZone",
    commonZone: "commonZone",
    selectedfilters: "selectedfilters",
    permission: "permission",
    permissionSaved: "permissionSaved",
    assignedFilters: "assignedFilters",
    selectedFilters: "selectedFilters",
    addDataFilter: "addDataFilter",
    editDataFilter: "editDataFilter",
    dataFilters: "dataFilters",
    schedules: "schedules",
    assignedSchedules: "assignedSchedules",
    selectedAMode: "selectedAMode",
    mode: "mode",
    selectAnActivePeriod: "selectAnActivePeriod",
    addSchedule: "addSchedule",
    editSchedule: "editSchedule",
    syncAllDevices: "syncAllDevices",
    syncAllDevicesMessage: "syncAllDevicesMessage",
    syncAllControllerMessage: "syncAllControllerMessage",
    operator: "operator",
    deviceScheduleSaved: "deviceScheduleSaved",
    outputs: "outputs",
    editOutputsForMode: "editOutputsForMode",
    outputStates: "outputStates",
    linkedTo: "linkedTo",
    discovered: "discovered",
    selectController: "selectController",
    selectPeripherals: "selectPeripherals",
    selectedPeripherals: "selectedPeripherals",
    peripherals: "peripherals",
    autoInstallPeripherals: "autoInstallPeripherals",
    absenteeismCurrentWeek: "absenteeismCurrentWeek",
    mon: "mon",
    tue: "tue",
    wed: "wed",
    thu: "thu",
    fri: "fri",
    sat: "sat",
    sun: "sun",
    hol: "hol",
    selectIpDevices: "selectIpDevices",
    selectAnIpDeviceToInstall: "selectAnIpDeviceToInstall",
    IPDevices: "IPDevices",
    selectedIpDevices: "selectedIpDevices",
    none: "none",
    replaceMasterController: "replaceMasterController",
    controllerToReplace: "controllerToReplace",
    replaceWith: "replaceWith",
    successfullyReplacedController: "successfullyReplacedController",
    replaceControllerMessage: "replaceControllerMessage",
    replace: "replace",
    selectReplacementDevice: "selectReplacementDevice",
    transactionsAlarms: "transactionsAlarms",
    transactionsDenied: "transactionsDenied",
    transactionsStatus: "transactionsStatus",
    defaultRecord: "defaultRecord",
    absent: "absent",
    selectAFilterType: "selectAFilterType",
    selectAFilterTypeCategory: "selectAFilterTypeCategory",
    filterType: "filterType",
    filterCategory: "filterCategory",
    selectDateFilter: "selectDateFilter",
    filter: "filter",
    zoneOccupancy: "zoneOccupancy",
    dayOfWeek: "dayOfWeek",
    hoursWorked: "hoursWorked",
    hoursWorkedTillNow: "hoursWorkedTillNow",
    advancedScan: "advancedScan",
    addRange: "addRange",
    specificIP: "specificIP",
    selectRange: "selectRange",
    startIpAddress: "startIpAddress",
    endIpAddress: "endIpAddress",
    ipRangeSaved: "ipRangeSaved",
    selectBrand: "selectBrand",
    selectABrand: "selectABrand",
    selectSiteToSaveTo: "selectSiteToSaveTo",
    selectSiteToSaveToDesc: "selectSiteToSaveToDesc",
    dualCard: "dualCard",
    dualCardDetected: "dualCardDetected",
    lowCard: "lowCard",
    highCard: "highCard",
    selected: "selected",
    backToMain: "backToMain",
    loadItemFailed: "loadItemFailed",
    loadTopicFailed: "loadTopicFailed",
    loadFilterFailed: "loadFilterFailed",
    loadSelectOptionFailed: "loadSelectOptionFailed",
    loadCategoriesFailed: "loadCategoriesFailed",
    failedToGenerateReport: "failedToGenerateReport",
    enrolViaIdemiaVisionPass: "enrolViaIdemiaVisionPass",
    enrolViaIdemiaVisionPassSp: "enrolViaIdemiaVisionPassSp",
    failedToFindAvailablePlugin: "failedToFindAvailablePlugin",
    pleaseSelectMasterControllerDevice: "pleaseSelectMasterControllerDevice",
    engineSelectedDevicesOnly: "engineSelectedDevicesOnly",
    syncSelectedDevicesOnly: "syncSelectedDevicesOnly",
    selectedDevices: "selectedDevices",
    eventActions: "eventActions",
    enrolFaceCamera: "enrolFaceCamera",
    imageCaptured: "imageCaptured",
    face: "face",
    camera: "camera",
    engineStatus: "engineStatus",
    invalidPhoneNumber: "invalidPhoneNumber",
    phoneNumberFieldTooltip: "phoneNumberFieldTooltip",
    possibleValidPhoneNumberWarning: "possibleValidPhoneNumberWarning",
    scanCard: "scanCard",
    download: "download",
    cardNumber: "cardNumber",
    assignPermissions: "assignPermissions",
    assignSecurityPolicy: "assignSecurityPolicy",
    enrolQrCode: "enrolQrCode",
    generateQrCode: "generateQrCode",
    qrCodeDescription: "qrCodeDescription",
    facial: "facial",
    assigned: "assigned",
    created: "created",
    updated: "updated",
    unassigned: "unassigned",
    deleted: "deleted",
    relationship: 'relationship',
    suspendWithAlarm: "suspendWithAlarm",
    accessAndTime: "accessAndTime",
    suspend: "suspend",
    idNumber: "idNumber",
    hosted: "hosted",
    scheduledTour: "scheduledTour",
    accessOverride: "accessOverride",
    issueNo: "issueNo",
    specialEvent: "specialEvent",
    before: "before",
    after: "after",
    newRandomPAC: "newRandomPAC",
    activeMobileAccessAccount: "activeMobileAccessAccount",
    endDateRequired: "endDateRequired",
    recipient: "recipient",
    notification: "notification",
    selectNotificationType: "selectNotificationType",
    setNotificationName: "setNotificationName",
    notificationType: "notificationType",
    notificationName: "notificationName",
    selectTheReport: "selectTheReport",
    emailTemplate: "emailTemplate",
    template: "template",
    emailAccountSetting: "emailAccountSetting",
    emailSubject: "emailSubject",
    emailBody: "emailBody",
    disclaimer: "disclaimer",
    sendToRecipient: "sendToRecipient",
    copyToRecipient: "copyToRecipient",
    sendTo: "sendTo",
    copyTo: "copyTo",
    schedule: "schedule",
    describeThisReport: "describeThisReport",
    recurrencePattern: "recurrencePattern",
    notificationSaved: "notificationSaved",
    recurrenceRange: "recurrenceRange",
    rangeOfrecurrence: "rangeOfrecurrence",
    recurEvery: "recurEvery",
    ofEvery: "ofEvery",
    dayDays: "dayDays",
    weeksOn: "weeksOn",
    weekWeeks: "weekWeeks",
    monthMonths: "monthMonths",
    yearYears: "yearYears",
    reportType: "reportType",
    atLeastOneSendToRecipientNeedsToBeSelected: "atLeastOneSendToRecipientNeedsToBeSelected",
    daily: "daily",
    weekly: "weekly",
    monthly: "monthly",
    yearly: "yearly",
    every: "every",
    everyWeekday: "everyWeekday",
    the: "the",
    on: "on",
    onThe: "onThe",
    first: "first",
    second: "second",
    third: "third",
    fourth: "fourth",
    last: "last",
    endBy: "endBy",
    endAfter: "endAfter",
    noEndDate: "noEndDate",
    recur: "recur",
    recurDay: "recurDay",
    yearYearsOn: "yearYearsOn",
    yearYearsOnThe: "yearYearsOnThe",
    reportTypeUpdated: "reportTypeUpdated",
    couldNotUpdateTheRecord: "couldNotUpdateTheRecord",
    start: "start",
    occurrences: "occurrences",
    emailAccount: "emailAccount",
    emailAccounts: "emailAccounts",
    default: "default",
    outgoingServer: "outgoingServer",
    portNumber: "portNumber",
    authentication: "authentication",
    ssl: "ssl",
    tls: "TLS",
    failed: "failed",
    emailAccountCreated: "emailAccountCreated",
    emailAccountUpdated: "emailAccountUpdated",
    incomingServer: "incomingServer",
    outgoingPort: "outgoingPort",
    incomingPort: "incomingPort",
    authenticationRequired: "authenticationRequired",
    secureConnectionSSL: "secureConnectionSSL",
    secureConnectionTLS: "secureConnectionTLS",
    testEmailSettings: "testEmailSettings",
    testingSettings: "testingSettings",
    defaultAccount: "defaultAccount",
    pleaseSelectAnOccurrence: "pleaseSelectAnOccurrence",
    pleaseSelectAWeek: "pleaseSelectAWeek",
    pleaseSelectADay: "pleaseSelectADay",
    pleaseSelectAMonth: "pleaseSelectAMonth",
    pleaseSelectEveryOrEveryWeekday: "pleaseSelectEveryOrEveryWeekday",
    pleaseEnterAValidNumberForDays: "pleaseEnterAValidNumberForDays",
    numberOfDaysMustBeBetween1And31: "numberOfDaysMustBeBetween1And31",
    pleaseSelectDayOrThe: "pleaseSelectDayOrThe",
    PleaseEnterDayValue: "PleaseEnterDayValue",
    PleaseEnterMonthValue: "PleaseEnterMonthValue",
    pleaseEnterAValidMonthNumberBetween1And12: "pleaseEnterAValidMonthNumberBetween1And12",
    pleaseEnterRecurrence: "pleaseEnterRecurrence",
    pleaseSelectAtLeastOneDay: "pleaseSelectAtLeastOneDay",
    pleaseSelectOnOrOnThe: "pleaseSelectOnOrOnThe",
    pleaseEnterAValidNumberForRecurRange1And99: "pleaseEnterAValidNumberForRecurRange1And99",
    startAndEndAfter: "startAndEndAfter",
    startAndEndBy: "startAndEndBy",
    dailyRecurEveryDay: "dailyRecurEveryDay",
    recurEveryWeekday: "recurEveryWeekday",
    recurEveryWeekWeeks: "recurEveryWeekWeeks",
    recurEveryMonthMonths: "recurEveryMonthMonths",
    recurSpecificMonth: "recurSpecificMonth",
    recurEveryYear: "recurEveryYear",
    recurEveryYearWithMonthAndDay: "recurEveryYearWithMonthAndDay",
    dontReplyToThisEmailAddress: "dontReplyToThisEmailAddress",
    notificationUpdated: "notificationUpdated",
    selectTheEvent: "selectTheEvent",
    eventType: "eventType",
    filterBy: "filterBy",
    deviceName: "deviceName",
    atLeastOneEventNeedsToBeSelected: "atLeastOneEventNeedsToBeSelected",
    atLeastOneOptionNeedsToBeSelected: "atLeastOneOptionNeedsToBeSelected",
    aMaximimumOf20RecordsCanBeSelected: "aMaximimumOf20RecordsCanBeSelected",
    alarmType: "alarmType",
    lastTriggered: "lastTriggered",
    account: "account",
    locks: "locks",
    lockPresets: "lockPresets",
    allLocks: "allLocks",
    lockPresetSaved: "lockPresetSaved",
    assignedLocks: "assignedLocks",
    lockSaved: "lockSaved",
    passwordChangedSuccessfully: "passwordChangedSuccessfully",
    currentMonth: "currentMonth",
    currentWeek: "currentWeek",
    yesterday: "yesterday",
    lastWeek: "lastWeek",
    lastYear: "lastYear",
    lastMonth: "lastMonth",
    lastThreeDays: "lastThreeDays",
    lastTwoWeeks: "lastTwoWeeks",
    lastFourWeeks: "lastFourWeeks",
    lastSixMonths: "lastSixMonths",
    specificDate: "specificDate",
    dateRange: "dateRange",
    dateFilter: "dateFilter",
    Commands: "Commands",
    personTracker: "personTracker",
    monitorCommsQueue: "monitorCommsQueue",
    monitorDoor: "monitorDoor",
    liveTransactions: "liveTransactions",
    shortcut: "shortcut",
    emergencyOpen: "emergencyOpen",
    emergencyLockdown: "emergencyLockdown",
    apbReset: "apbReset",
    failedToExecuteCommand: "failedToExecuteCommand",
    resetAPBOnlySupportedOnSitesAndControllers: "resetAPBOnlySupportedOnSitesAndControllers",
    defaultZoneName: "defaultZoneName",
    defaultDoorName: "defaultDoorName",
    editor: "editor",
    failedToCreateWidget: "failedToCreateWidget",
    widgetAlreadyExistsCannotCreateDuplicateWidget: "widgetAlreadyExistsCannotCreateDuplicateWidget",
    userDetails: "userDetails",
    profileImage: "profileImage",
    selectCategoryType: "selectCategoryType",
    categoryType: "categoryType",
    credentialType: "credentialType",
    accessGroupsAssigned: "accessGroupsAssigned",
    makeModel: "makeModel",
    RegistrationNr: "RegistrationNr",
    widgetMoveConfirmation: "widgetMoveConfirmation",
    changeDashboardLayout: "changeDashboardLayout",
    selectedType: "selectedType",
    widgetConfig: "widgetConfig",
    menu: "menu",
    widgetConfiguration: "widgetConfiguration",
    titleTextColor: "titleTextColor",
    titleBackgroundColor: "titleBackgroundColor",
    foregroundColor: "foregroundColor",
    preview: "preview",
    resetDefault: "resetDefault",
    selectMenu: "selectMenu",
    musteringPoint: "musteringPoint",
    mustered: "mustered",
    exited: "exited",
    unaccounted: "unaccounted",
    manuallyMustered: "manuallyMustered",
    lastLocation: "lastLocation",
    lastSeenTime: "lastSeenTime",
    contactNumber: "contactNumber",
    generalMusteringReport: "generalMusteringReport",
    author: "author",
    lastRun: "lastRun",
    totalPersonnelOnSite: "totalPersonnelOnSite",
    totalPersonnelMustered: "totalPersonnelMustered",
    totalPersonnelUnaccountedFor: "totalPersonnelUnaccountedFor",
    securityPolicy: "securityPolicy",
    securityPolicies: "securityPolicies",
    securityPolicyUpdated: "securityPolicyUpdated",
    generalMusteringReportAbsentTab: "generalMusteringReportAbsentTab",
    generalMusteringReportMusteredTab: "generalMusteringReportMusteredTab",
    generalMusteringReportExitedTab: "generalMusteringReportExitedTab",
    unaccountedFor: "unaccountedFor",
    generalMusteringReportUnaccountedForTab: "generalMusteringReportUnaccountedForTab",
    lockerAddress: "lockerAddress",
    lockerHub: "lockerHub",
    lockerType: "lockerType",
    assignedTo: "assignedTo",
    lockers: "lockers",
    locker: "locker",
    pleaseSelectRows: "pleaseSelectRows",
    allLockers: "allLockers",
    lockerPresets: "lockerPresets",
    showAvailableLockers: "showAvailableLockers",
    releaseNow: "releaseNow",
    lockersReleased: "lockersReleased",
    cantReleaseLockersMessage: "cantReleaseLockersMessage",
    manuallyMuster: "manuallyMuster",
    mustering: "mustering",
    securityPolicyPassword: "securityPolicyPassword",
    sevenDaysToPasswordExpired: "sevenDaysToPasswordExpired",
    oneDayToPasswordExpire: "oneDayToPasswordExpire",
    lessThanOneMonthToExpire: "lessThanOneMonthToExpire",
    passwordHasExpired: "passwordHasExpired",
    firstLoginPasswordChange: "firstLoginPasswordChange",
    passwordUppercase: "passwordUppercase",
    passwordLowercase: "passwordLowercase",
    passwordDigit: "passwordDigit",
    passwordSpecialCharacter: "passwordSpecialCharacter",
    passwordLength: "passwordLength",
    relaxed: "relaxed",
    strict: "strict",
    normal: "normal",
    selectTimeFilter: "selectTimeFilter",
    timeFilter: "timeFilter",
    siteExitMessage: "siteExitMessage",
    stillOnSite: "stillOnSite",
    siteExits: "siteExits",
    userIdCsn: "userIdCsn",
    buttonConfiguration: "buttonConfiguration",
    idemia: "idemia",
    controlId: "controlId",
    hikVision: "hikVision",
    hidAmico: "hidAmico",
    skip: "skip",
    policySaved: "policySaved",
    notMeetingRequirements: "notMeetingRequirements",
    securityPolicyInfo: "securityPolicyInfo",
    button: "button",
    buttonText: "buttonText",
    icon: "icon",
    invalidIpAddressRange: "invalidIpAddressRange",
    lock: "lock",
    unlock: "unlock",
    discover: "discover",
    available: "available",
    inuse: "inUse",
    clockingEvent: "clockingEvent",
    pleaseEnterAValidSerialNumber: "pleaseEnterAValidSerialNumber",
    pleaseEnterAValidFixedAddress: "pleaseEnterAValidFixedAddress",
    pleaseEnterAValidMacAddress: "pleaseEnterAValidMacAddress",
    customCardFormat: "customCardFormat",
    maskLengthError: "maskLengthError",
    maskHexError: "maskHexError",
    systemSite: "systemSite",
    action: "action",
    field: "field",
    addFilter: "addFilter",
    chooseColumns: "chooseColumns",
    downloadPlugins: "downloadPlugins",
    exportLists: "exportLists",
    performSearch: "performSearch",
    siteToSaveTo: "siteToSaveTo",
    sortColumn: "sortColumn",
    setActivePeriod: "setActivePeriod",
    limitCapacity: "limitCapacity",
    activeDirectory: "activeDirectory",
    clickatell: "clickatell",
    ldap: "ldap",
    mobileAccess: "mobileAccess",
    settingUpTheAccount: "settingUpTheAccount",
    queryingAccountDetails: "queryingAccountDetails",
    availableCredentials: "availableCredentials",
    systemEmail: "systemEmail",
    assignFloors: "assignFloors",
    applyFormatsToCardType: "applyFormatsToCardType",
    formatTypes: "formatTypes",
    cardFormatH10301: "cardFormatH10301",
    cardFormatH10302H10304: "cardFormatH10302H10304",
    interLeadingRouting: "interLeadingRouting",
    assignToEnrolment: "assignToEnrolment",
    assignReader: "assignReader",
    configureInterLeadingZone: "configureInterLeadingZone",
    configureMultiCard: "configureMultiCard",
    addCardCredential: "addCardCredential",
    addFingerCredential: "addFingerCredential",
    addFaceCredential: "addFaceCredential",
    addMobileCredential: "addMobileCredential",
    assignAccessGroup: "assignAccessGroup",
    captureProfilePicViaWebCam: "captureProfilePicViaWebCam",
    deleteProfilePic: "deleteProfilePic",
    uploadProfilePic: "uploadProfilePic",
    changeCommsPorts: "changeCommsPorts",
    diagnosticsReporting: "diagnosticsReporting",
    setSafeIp: "setSafeIp",
    setStaticIpAddress: "setStaticIpAddress",
    assignActionsToEvent: "assignActionsToEvent",
    changePresets: "changePresets",
    setDefaultMode: "setDefaultMode",
    distributedTemplates: "distributedTemplates",
    randomSearch: "randomSearch",
    specialCodes: "specialCodes",
    assignActionsToAllowedEvents: "assignActionsToAllowedEvents",
    assignActionsToDeniedEvents: "assignActionsToDeniedEvents",
    configureActions: "configureActions",
    configureInputs: "configureInputs",
    officeMode: "officeMode",
    unlockOnFirstTag: "unlockOnFirstTag",
    configureAudioVisualStates: "configureAudioVisualStates",
    configureParameters: "configureParameters",
    configureSchedules: "configureSchedules",
    extendedTimeout: "extendedTimeout",
    poolCount: "poolCount",
    loggingThreshold: "loggingThreshold",
    fastUpload: "fastUpload",
    verifyUserId: "verifyUserId",
    similarityThreshold: "similarityThreshold",
    maximumIdentificationTime: "maximumIdentificationTime",
    fieldOfView: "fieldOfView",
    ledActivation: "ledActivation",
    wiegandOutSize: "wiegandOutSize",
    wiegandOutMode: "wiegandOutMode",
    lockerTypes: "lockerTypes",
    showProfilePicWhenLoggedIn: "showProfilePicWhenLoggedIn",
    roles: "roles",
    systemOwner: "systemOwner",
    siteAdministrator: "siteAdministrator",
    siteInstaller: "siteInstaller",
    siteReports: "siteReports",
    siteReceptionist: "siteReceptionist",
    siteGuard: "siteGuard",
    addSiteCode: "addSiteCode",
    siteCardMask: "siteCardMask",
    assignDoors: "assignDoors",
    lockoutDelays: "lockoutDelays",
    accountTypes: "accountTypes",
    addNewCategory: "addNewCategory",
    addEnrolmentByCategory: "addEnrolmentByCategory",
    addFields: "addFields",
    assignFieldsToCategory: "assignFieldsToCategory",
    findByReadCard: "findByReadCard",
    installDevice: "installDevice",
    firmwareUpgrade: "firmwareUpgrade",
    replaceFaultyHardware: "replaceFaultyHardware",
    uninstallDevice: "uninstallDevice",
    requestLicense: "requestLicense",
    startStopAutoSync: "startStopAutoSync",
    transactionReport: "transactionReport",
    areas: "areas",
    hardwareInstallation: "hardwareInstallation",
    alarmTransactions: "alarmTransactions",
    statusTransactions: "statusTransactions",
    deniedTransactions: "deniedTransactions",
    generalMustering: "generalMustering",
    musteringPoints: "musteringPoints",
    manualMustering: "manualMustering",
    monitorTransactions: "monitorTransactions",
    commonEvents: "commonEvents",
    filterByType: "filterByType",
    editorMode: "editorMode",
    deleteARecord: "deleteARecord",
    notFound: "notFound",
    helpTopicTopicNotFoundMessage: "helpTopicTopicNotFoundMessage",
    accessProfiles: "accessProfiles",
    accessProfile: "accessProfile",
    profiles: "profiles",
    groupingName: "groupingName",
    selectedAccessGroups: "selectedAccessGroups",
    assignAccessProfiles: "assignAccessProfiles",
    importSoftwareLicense: "importSoftwareLicense",
    failedToReadLicense: "failedToReadLicense",
    syncBiometricOnly: "syncBiometricOnly",
    syncNonBioOnly: "syncNonBioOnly",
    frequence: "frequence",
    firstIn: "firstIn",
    lastSeen: "lastSeen",
    exitPoints: "exitPoints",
    creditsAvailable: "creditsAvailable",
    testAccount: "testAccount",
    testAccountFailed: "testAccountFailed",
    unableToDetermineLanguage: "unableToDetermineLanguage",
    connectionLostToServer: "connectionLostToServer",
    deleteProfileError: "deleteProfileError",
    accessProfileChanges: "accessProfileChanges",
    accessGroupChanges: "accessGroupChanges",
    addingGroups: "addingGroups",
    removingGroups: "removingGroups",
    addingProfiles: "addingProfiles",
    removingProfiles: "removingProfiles",
    noChangesMade: "noChangesMade",
    selectedWithCount: "selectedWithCount",
    enrolViaHidMobileAccess: "Enrol via HID Mobile Access",
    enrolViaStidMobile: "Enrol via STid Mobile",
    or: "or",
    reportSubTitle: "reportSubTitle",
    reportFilename: "reportFilename",
    unlicensedFeature: "unlicensedFeature",
    unlicensed: "unlicensed",
    accountDisabled: "accountDisabled",
    templateDefault: "templateDefault",
    userDefined: "userDefined",
    textField: "textField",
    multiLineTextField: "multiLineTextField",
    radioButtons: "radioButtons",
    checkBoxes: "checkBoxes",
    textAreaWithCharacterCount: "textAreaWithCharacterCount",
    selectEvent: "selectEvent",
    selectReader: "selectReader",
    selectZone: "selectZone",
    selectMessage: "selectMessage",
    image: "image",
    selectDeviceTimePattern: "selectDeviceTimePattern",
    selectMultipleDeviceTimePatterns: "selectMultipleDeviceTimePatterns",
    selectProfile: "selectProfile",
    selectCustom: "selectCustom",
    selectDepartment: "selectDepartment",
    selectCompany: "selectCompany",
    selectDateTime: "selectDateTime",
    selectEmailAddress: "selectEmailAddress",
    selectDateRange: "selectDateRange",
    selectCategory: "selectCategory",
    selectMaster: "selectMaster",
    selectCustomMulti: "selectCustomMulti",
    selectMasterType: "selectMasterType",
    selectProvided: "selectProvided",
    selectAccessGroup: "selectAccessGroup",
    assignedToAll: "assignedToAll",
    custom: "custom",
    state: "state",
    lastChanged: "lastChanged",
    changedBy: "changedBy",
    totalFor: "totalFor",
    failedToApplyFilter: "failedToApplyFilter",
    unknown: "unknown",
    controllerDetails: "controllerDetails",
    downstreamDevices: "downstreamDevices",
    detectDownstreamIpDevices: "detectDownstreamIpDevices",
    detectPeripheralsDirectly: "detectPeripheralsDirectly",
    authenticatingMessage: "authenticatingMessage",
    searchingForDevicesMessage: "searchingForDevicesMessage",
    pingControllerErrorMessage: "pingControllerErrorMessage",
    identificationMode: "identificationMode",
    handsFree: "handsFree",
    tapTap: "tapTap",
    remote: "remote",
    phoneConfiguration: "phoneConfiguration",
    siteCode: "siteCode",
    bleNfcKey: "bleNfcKey",
    data: "data",
    offset: "offset",
    reverseBytes: "reverseBytes",
    power: "power",
    numberOfBytes: "numberOfBytes",
    directContact: "directContact",
    upToMeters: "upToMeters",
    smartPhoneUnlock: "smartPhoneUnlock",
    remoteButton: "remoteButton",
    improKeyAndSiteCode: "improKeyAndSiteCode",
    customKeyAndSiteCode: "customKeyAndSiteCode",
    twist: "twist",
    reverseBytesOrderOfPACS: "reverseBytesOrderOfPACS",
    siteCodeType: "siteCodeType",
    HidPresetValidation: "HidPresetValidation",
    thermal: "Thermal",
    selectFinger: "selectFinger",
    deviceSelection: "deviceSelection",
    selectCard: "selectCard",
    pluginDeviceCard: "pluginDeviceCard",
    upToCentimeters: "upToCentimeters",
    licensed: "licensed",
    licenseExpiredAt: "licenseExpiredAt",
    licenseExpiringSoon: "licenseExpiringSoon",
    licenseExpiredShort: "licenseExpiredShort",
    licenseExpiringSoonShort: "licenseExpiringSoonShort",
    exportSTid: "exportSTid",
    exportHID: "exportHID",
    exportSTidAndHID: "exportSTidAndHID",
    selectAtLeastOneDevice: "selectAtLeastOneDevice",
    noDeviceSelected: "noDeviceSelected",
    noFileSelected: "noFileSelected",
    usedWith: "usedWith",
    improMobileReaders: "improMobileReaders",
    hidReaders: "hidReaders",
    stidReaders: "stidReaders",
    exportLicenseFailed: "exportLicenseFailed",
    specialEvent1: "specialEvent1",
    specialEvent2: "specialEvent2",
    hidTap: "hidTap",
    months: "months",
    minimumLength: "minimumLength",
    passwordsRemembered: "passwordsRemembered",
    enforceUppercase: "enforceUppercase",
    enforceLowercase: "enforceLowercase",
    enforceDigit: "enforceDigit",
    enforceSpecialCharacter: "enforceSpecialCharacter",
    enforcePasswordLifetime: "enforcePasswordLifetime",
    enforceMinimumLength: "enforceMinimumLength",
    enforcePasswordHistory: "enforcePasswordHistory",
    enforceFirstPasswordChange: "enforceFirstPasswordChange",
    noDataFound: "noDataFound",
    addNewSecurityPolicy: "addNewSecurityPolicy",
    assignUserLogins: "assignUserLogins",
    certificates: "certificates",
    certificate: "certificate",
    chooseCertificate: "chooseCertificate",
    webserver: "webserver",
    issuedTo: "issuedTo",
    issuer: "issuer",
    issuedOn: "issuedOn",
    commonName: "commonName",
    organisation: "organisation",
    organisationalUnit: "organisationalUnit",
    validityPeriod: "validityPeriod",
    fingerprints: "fingerprints",
    publicKey: "publicKey",
    expiresOn: "expiresOn",
    import: "import",
    export: "export",
    revoke: "revoke",
    revoked: "revoked",
    notRevoked: "notRevoked",
    revokeCertificate: "revokeCertificate",
    certificateRevoked: "certificateRevoked",
    revokeCAWarning:"revokeCAWarning",
    revokeCertContent: "revokeCertContent",
    revokeCertificateWarningDescription: "revokeCertificateWarningDescription",
    generate: "generate",
    recreate: "recreate",
    generateCertificate: "generateCertificate",
    generateAndUploadCertificate: "generateAndUploadCertificate",
    generateCertificateWarningDescription: "generateCertificateWarningDescription",
    generateAndUploadCertificateWarningDescription: "generateAndUploadWarningDescription",
    willTakeAFewMinutes: "willTakeAFewMinutes",
    alias: "alias",
    validityIn: "validityIn",
    validFor: "validFor",
    subjectAlternativeName: "subjectAlternativeName",
    years: "years",
    notPartOfcertificate: "notPartOfcertificate",
    dnsLengthError: "dnsLengthError",
    dnsInvalidCharactersError: "dnsInvalidCharactersError",
    dnsStartsWithHyphenError: "dnsStartsWithHyphenError",
    dnsEndsWithHyphenError: "dnsEndsWithHyphenError",
    uriPrefixError: "uriPrefixError",
    uriFormatError: "uriFormatError",
    uriInvalidPortError: "uriInvalidPortError",
    active: "active",
    inActive: "inActive",
    current: "current",
    includeNonCurrent: "includeNonCurrent",
    importCertificate: "importCertificate",
    exportCertificate: "exportCertificate",
    certificatePassword: "certificatePassword",
    certificateType: "certificateType",
    chooseFile: "chooseFile",
    certificateImportError: "certificateImportError",
    certificateExportError: "certificateExportError",
    certificateRecreateError: "certificateRecreateError",
    recreateCertificate: "recreateCertificate",
    lastModifiedBy: "lastModifiedBy",
    certificateAuthority: "certificateAuthority",
    domainNameSystem: "domainNameSystem",
    uniformResourceIdentifier: "uniformResourceIdentifier",
    internetProtocol: "internetProtocol",
    url: "url",
    sendCertificateToControllerMessage: "sendCertificateToControllerMessage",
    sendCertificateToEc3ControllerMessage: "sendCertificateToEc3ControllerMessage",
    sendCertificateToControllerError: "sendCertificateToControllerError",
    sendCertificateToEc3ControllerError: "sendCertificateToEc3ControllerError",
    certificateGenerationError: "certificateGenerationError",
    certificateRecreationError: "certificateRecreationError",
    getCertificateDetailsError: "getCertificateDetailsError",
    tap: "tap",
    twistAndGo: "twistAndGo",
    gettingCertificateDetailsError: "gettingCertificateDetailsError",
    algorithm: "algorithm",
    showMore: "showMore",
    activeCertificate: "activeCertificate",
    noCertificateInUseYet: "noCertificateInUseYet",
    updateCertificate: "updateCertificate",
    uploadCertificate: "uploadCertificate",
    siteCodeHex: "siteCodeHex",
    readerSerial: "readerSerial",
    keySize: "keySize",
    curve: "curve",
    selectShaAlgorithm: "selectShaAlgorithm",
    shaAlgorithm: "shaAlgorithm",
    generateAsCertificateAuthority: "generateAsCertificateAuthority",
    ca: "ca",
    encryptionType: "encryptionType",
    rsa: "rsa",
    ecParam: "ecParam",
    bleNFCKeyValidationMessage: "bleNFCKeyValidationMessage",
    stidCreditsAvailable: "stidCreditsAvailable",
    connectionName: "connectionName",
    connection: "connection",
    host: "host",
    base: "base",
    anonymousConnection: "anonymousConnection",
    testConnection: "testConnection",
    fetchDNs: "fetchDNs",
    uniqueIdentifierLdap: "uniqueIdentifierLdap",
    choose: "choose",
    manual: "manual",
    controllerCertificates: "controllerCertificates",
    selectedCertificate: "selectedCertificate",
    secureComms: "secureComms",
    certificateTypePfx: "certificateTypePfx",
    certificateTypePem: "certificateTypePem",
    stidCardMode: "stidCardMode",
    standardModes: "standardModes",
    hidIdentificationModeHint: "hidIdentificationModeHint",
    tlsUrl: "tlsUrl",
    tlsPort: "tlsPort",
    clientId: "clientId",
    usage: "usage",
    certType: "certType",
    swCert: "swCert",
    pemCert: "pemCert",
    pemPrivateKey: "pemPrivateKey",
    pemCaCertificate: "pemCaCertificate",
    pemPassword: "pemPassword",
    tlsBrokerServiceLocation: "tlsBrokerServiceLocation",
    tlsBrokerCrlActions: "tlsBrokerCrlActions",
    refreshCrlCompleted: "refreshCrlCompleted",
    refreshCrlFailed: "refreshCrlFailed",
    crlImportSuccess: "crlImportSuccess",
    tlsBrokerCertificate: "tlsBrokerCertificate",
    browse: "browse",
    importPfx: "importPfx",
    importPem: "importPem",
    importPemCertificateTitle: "importPemCertificateTitle",
    primoCertificate: "primoCertificate",
    primoCertificateDescription: "primoCertificateDescription",
    brokerCertificate: "brokerCertificate",
    vingcardCertificate: "vingcardCertificate",
    brokerCertificateDescription: "brokerCertificateDescription",
    lan: "lan",
    cloud: "cloud",
    certificateValidity: "certificateValidity",
    encryption: "encryption",
    mqttBrokerConnectionSettings: "mqttBrokerConnectionSettings",
    mqttBrokerServiceLocationTip: "mqttBrokerServiceLocationTip",
    certificateTypes: "certificateTypes",
    importPfxCertificateTitle: "importPfxCertificateTitle",
    generateSelfSignedCert: "generateSelfSignedCert",
    saveChangesBeforeTesting: "saveChangesBeforeTesting",
    verify: "verify",
    refreshCrl: "refreshCrl",
    noRefreshCrl: "noRefreshCrl",
    importCrl: "importCrl",
    brokerServiceLocationVerified: "brokerServiceLocationVerified",
    mobileNumber: "mobileNumber",
    enterNewPassword: "enterNewPassword",
    createAsCA: "createAsCA",
    recreateCAError: "recreateCAError",
    successConnectedToAccount: "successConnectedToAccount",
    successConnectedToDisabledAccount: "successConnectedToDisabledAccount",
    brokerUrlOrIp: "brokerUrlOrIp",
    brokerPort: "brokerPort",
    installDownstreamIpDevices: "installDownstreamIpDevices",
    mobileLicensePending: "mobileLicensePending",
    pendingUpdate: "pendingUpdate",
    certificateValidTooltip: "certificateValidTooltip",
    certificateExpiredTooltip: "certificateExpiredTooltip",
    validCertificate: "validCertificate",
    expiredCertificate: "expiredCertificate",
    certificateStatus: "certificateStatus",
    certificateImported: "certificateImported",
    enrolViaVingCard: "enrolViaVingCard",
    guest: "guest",
    staff: "staff",
    userGroup: "userGroup",
    checkInTime: "checkInTime",
    checkOutTime: "checkOutTime",
    checkInDate: "checkInDate",
    checkOutDate: "checkOutDate",
    noOfNights: "noOfNights",
    userExpirationDate: "userExpirationDate",
    userExpirationTime: "userExpirationTime",
    noOfCards: "noOfCards",
    roomNo: "roomNo",
    timeSchedule: "timeSchedule",
    pleaseWaitWhileWeTestTheAccount: "pleaseWaitWhileWeTestTheAccount",
    transactionPolling: "transactionPolling",
    pollingInterval: "pollingInterval",
    syncWithVingcard: "syncWithVingcard",
    lastSynced: "lastSynced",
    ldapPerson: "ldapPerson",
    searchByCn: "searchByCn",
    search: "search",
    foundMatches: "foundMatches",
    accessControl: "accessControl",
    systemSetup: "systemSetup",
    emergencyAndSafety: "emergencyAndSafety",
    vingcardTransactions: "vingcardTransactions",
    registrationNumber: "registrationNumber",
    loadingDoorsPleaseWait: "loadingDoorsPleaseWait",
    cardEncodedSuccessfully: "cardEncodedSuccessfully",
    encodeCard: "encodeCard",
    cardType: "cardType",
    mainRoomNumber: "mainRoomNumber",
    selectDoors: "selectDoors",
    captureDetails: "captureDetails",
    syncWithVingcardTooltip: "syncWithVingcardTooltip",
    syncNow: "syncNow",
    resetAPB: "resetAPB",
    selectMultipleReaders: "selectMultipleReaders",
    triggeredBy: "triggeredBy",
    lowestLimits: "lowestLimits",
    lowestLimitsTip: "lowestLimitsTip",
    highestLimits: "highestLimits",
    highestLimitsTip: "highestLimitsTip",
    licenseIncompatibleVersion: "licenseIncompatibleVersion",
    licenseIncompatibleVersionShort: "licenseIncompatibleVersionShort",
    enableMfa: "enableMfa",
    mfa: "mfa",
    scanQrCodeForAuthenticatorApp: "scanQrCodeForAuthenticatorApp",
    enterAuthenticatorCode: "enterAuthenticatorCode",
    authenticationCode: "authenticationCode",
    resetMfa: "resetMfa",
    resetMfaFailed: "resetMfaFailed",
    resetMfaSuccess: "resetMfaSuccess",
    applyRecommendedDefaultSettings: "applyRecommendedDefaultSettings",
    idemiaRecommendedCustomPropTooltip: "idemiaRecommendedCustomPropTooltip",
    duplicateEntryNotAllowed: "duplicateEntryNotAllowed",
    failedToLoadPresetTemplate: "failedToLoadPresetTemplate",
    acknowledge: "acknowledge",
    acknowledged: "acknowledged",
    unacknowledged: "unacknowledged",
    enterYourPassword: "enterYourPassword",
    verifyPassword: "verifyPassword",
    acknowledgeAlarmSuccessfully: "acknowledgeAlarmSuccessfully",
    alarmsAlreadyAcknowledged: "alarmsAlreadyAcknowledged",
    crlRefreshTitle: "crlRefreshTitle",
    crlWarningDescription: "crlWarningDescription",
    crlRefresh: "crlRefresh",
    crlRemoveTitle: "crlRemoveTitle",
    crlWarningRemovingDescription: "crlWarningRemovingDescription",
    crlRemove: "crlRemove",
    removeCrlFailed: "removeCrlFailed",
    removeCrlCompleted: "removeCrlCompleted",
    crlImport: "crlImport",
    pemCrl: "pemCrl",
    linkCaCertificate: "linkCaCertificate",
    crlImportFileMissingError: "crlImportFileMissingError",
    certificateCrlUploadError: "certificateCrlUploadError",
    caLinkedCheckedFileMissingError: "caLinkedCheckedFileMissingError",
    priorityLevel: "priorityLevel",
    standard: "standard",
    passwordEasyToGuess: "passwordEasyToGuess",
    certificateRevocationManagement: "certificateRevocationManagement",
    crlManagementTip: "crlManagementTip",
    updateCrlTip: "updateCrlTip",
    importCrlTip: "importCrlTip",
    removeCrlTip: "removeCrlTip",
    passwordCharacterRepetition: "passwordCharacterRepetition",
    passwordSequentialCharacters: "passwordSequentialCharacters",
    passwordPolicyHint: "passwordPolicyHint",
    passwordPolicyNoRules: "passwordPolicyNoRules",
    acknowledgedBy: "acknowledgedBy",
    mifareBytesReversed: "mifareBytesReversed",
    byteReversed: "byteReversed",
    unsupportedExportFormat: "unsupportedExportFormat",
    lift: "lift",
    lifts: "lifts",
    startingFloor: "startingFloor",
    numberOfFloors: "numberOfFloors",
    liftSaved: "liftSaved",
    assignIoDevices: "assignIoDevices",
    assignedIoDevices: "assignedIoDevices",
    toBeAssigned: "toBeAssigned",
    toBeUnassigned: "toBeUnassigned",
    previewEmail: "previewEmail",
    floorGroups: "floorGroups",
    floorGroup: "floorGroup",
    floorGroupSaved: "floorGroupSaved",
    assignedLifts: "assignedLifts",
    assignedFloorGroups: "assignedFloorGroups",
    assignLifts: "assignLifts",
    assignFloorGroups: "assignFloorGroups",
    assignedAccessGroups: "assignedAccessGroups",
    assignedAccessProfiles: "assignedAccessProfiles",
    mapRelays: "mapRelays",
    addLift: "addLift",
    describeThisLift: "describeThisLift",
    selectBuilding: "selectBuilding",
    lastFloor: "lastFloor",
    selectFloors: "selectFloors",
    chooseLiftFloors: "chooseLiftFloors",
    assignIOModules: "assignIOModules",
    useExistingBuildingFloors: "useExistingBuildingFloors",
    primaryMustNotBeLessThanSecondary: "primaryMustNotBeLessThanSecondary",
    primaryMustBeGreaterThanSecondary: "primaryMustBeGreaterThanSecondary",
    primaryMustBeLessThanSecondary: "primaryMustBeLessThanSecondary",
    primaryMustNotBeEqualToSecondary: "primaryMustNotBeEqualToSecondary",
    primaryMustBeEqualToSecondary: "primaryMustBeEqualToSecondary",
    primaryMustNotBeGreaterThanSecondary: "primaryMustNotBeGreaterThanSecondary",
    autoCreatingFloors: "autoCreatingFloors",
    relays: "relays",
    failedFloorAutoCreateWarning: "failedFloorAutoCreateWarning",
    liftSavedSuccessfully: "liftSavedSuccessfully",
    floorGroupName: "floorGroupName",
    accessProfileName: "accessProfileName",
    savingLiftPleaseWait: "savingLiftPleaseWait",
    exportBundledCredentialRequest: "exportBundledCredentialRequest",
    preparingLicenseRequestForDownload: "preparingLicenseRequestForDownload",
    mapRelaysFloorWarning: "mapRelaysFloorWarning",
    mapRelaysIOModuleWarning: "mapRelaysIOModuleWarning",
    fromTo: "fromTo",
    customDeleteLiftMsg: "customDeleteLiftMsg",
    deletingLiftPleaseWait: "deletingLiftPleaseWait",
    liftAreas: "liftAreas",
    ioDevice: "ioDevice",
    relay: "relay",
    actionsUpdated: "actionsUpdated",
    passwordDefaultDetected: "passwordDefaultDetected",
    passwordChangedMessage:"passwordChangedMessage",
    securityNotice: "securityNotice",
    addEventBasedNotification: "addEventBasedNotification",
    addScheduledReportNotification: "addScheduledReportNotification",
    noRecipients: "noRecipients",
    whatIsIncludedInEventBasedNotification: "whatIsIncludedInEventBasedNotification",
    clientSecret: "clientSecret",
    tenantId: "tenantId",
    redirectUri: "redirectUri",
    adminConsent: "adminConsent",
    sso: "sso",
    continueWithDots: "continueWithDots",
    auth: "auth",
    identityProvider: "identityProvider",
    uniqueIdentifierAuth: "uniqueIdentifierAuth",
    ssoSign:"ssoSign",
    msSignIn:"msSignIn",
    googleSignIn:"googleSignIn",
    googleSignInNotActive: "googleSignInNotActive",
    msSignInNotActive: "msSignInNotActive",
    userEmail:"userEmail",
    createFloorGroupsPerFloor: "createFloorGroupsPerFloor",
    createFullAccessFloorGroup: "createFullAccessFloorGroup",
    createFullAccessProfile: "createFullAccessProfile",
    defaultPasswordMustBeChanged: "defaultPasswordMustBeChanged",
    liftOverview: "liftOverview",
    assigningPermissions: "assigningPermissions",
    setUpEmailAccount: "setUpEmailAccount",
    recipients: "recipients",
    recipientsEmailRequirementMessage: "recipientsEmailRequirementMessage",
    emailPreviewLoadError: "emailPreviewLoadError",
    resyncControllerPassword:"resyncControllerPassword",
    signInWithExistingAccount: "signInWithExistingAccount",
    identityProviderWithGroups: "identityProviderWithGroups",
    searchingForIdentityGroup: "searchingForIdentityGroup",
    selectIdpGroups:"selectIdpGroups",
    linkGroupToProfile:"linkGroupToProfile",
    selectProfileToLink:"selectProfileToLink",
    selectIdpGroup: "selectIdpGroup",
    groupName: "groupName",
    groupDescription: "groupDescription",
    selectedPermission: "selectedPermission",
    permissionName: "permissionName",
    searchGroup:"searchGroup",
    groupDetails:"groupDetails",
    searchByName: "searchByName",
    groupSaved: "groupSaved",
    identityProviderGroups: "identityProviderGroups",
    mapIdpGroup: "mapIdpGroup",
    selectPermission: "selectPermission",
    failedToLogin: "failedToLogin",
    selectedIdpGroup: "selectedIdpGroup",
    assignedIdentityProviderGroups: "assignedIdentityProviderGroups",
    enterNewClientSecret: "enterNewClientSecret",
    microsoftEntra:"microsoftEntra",
    ossEnabled: "ossEnabled",
    ossUpdater: "ossUpdater",
    ossValidityStart: "ossValidityStart",
    ossCredential: "ossCredential",
    ossId: "ossId",
    ossSiteId: "ossSiteId",
    ossValidityDuration: "ossValidityDuration",
    ossGroups: "ossGroups",
    ossGroup: "ossGroup",
    ossGroupSaved: "ossGroupSaved",
    assignedOssGroups: "assignedOssGroups",
    assignOssGroups: "assignOssGroups",
    devices: "devices",
    assignedDevices: "assignedDevices",
    assignDevices: "assignDevices",
    ossDevices: "ossDevices",
    installOssDevice: "installOssDevice",
    defaultUnlockTime: "defaultUnlockTime",
    extendedUnlockTime: "extendedUnlockTime",
    doorGroup: "doorGroup",
    unlockTime: "unlockTime",
    toggle: "toggle",
    toggleActive: "toggleActive",
    inactive: "inactive",
    doorGroupId: "doorGroupId",
    doorId: "doorId",
    ossPermLocked: "ossPermLocked",
    ossPrivileged: "ossPrivileged",
    addGroup: "addGroup",
    changeDefaultPassword:"changeDefaultPassword",
    features: "features",
    featuresTip: "featuresTip",
    importingLicensePleaseWait: "importingLicensePleaseWait",
    slimTag: "slimTag",
    isoAnimal: "isoAnimal",
    wriTag2048: "wriTag2048",
    wriTag128: "wriTag128",
    asciiBiometricMagstrip: "asciiBiometricMagstrip",
    rfInfraredTag: "rfInfraredTag",
    mifareTag: "mifareTag",
    enableTagTypesMifarePacsWarning: "enableTagTypesMifarePacsWarning",
    hidTag: "hidTag",
    vehicleRegistrationPlate: "vehicleRegistrationPlate",
    felicaTag: "felicaTag",
    general1356MHzTag: "general1356MHzTag",
    anyTagType: "anyTagType",
    genericPasswordWarning: "genericPasswordWarning",
    passwordUpdateRequired: "passwordUpdateRequired",
    failedToUpdateAccessAreaTree: "failedToUpdateAccessAreaTree",
    failedToLoadChildrenFor: "failedToLoadChildrenFor",
    loginType: "loginType",
    cannotUseDefaultPassword: "cannotUseDefaultPassword",
    failedToVerifyPassword: "failedToVerifyPassword",
    aMaximumOf100RecordsCanBeSelected: "aMaximumOf100RecordsCanBeSelected",
    dataTruncatedReduceRowsToExport: "dataTruncatedReduceRowsToExport",
    largeDatasetWarning: "largeDatasetWarning",
    unableToCreatePrintDocument: "unableToCreatePrintDocument",
    unableToOpenPrintPreview: "unableToOpenPrintPreview",
    pdfPrintFailed: "pdfPrintFailed",
    exportToExcelFailed: "exportToExcelFailed",
    myReports: "myReports",
    primaryKey: "primaryKey",
    auditType: "auditType",
    auditSubType: "auditSubType",
    runReport: "runReport",
    filtersHaveChanged: "filtersHaveChanged",
    keys: "keys",
    generateKey: "generateKey",
    importKey: "importKey",
    ossCardProvision: "ossCardProvision",
    piccKey: "piccKey",
    applicationId: "applicationId",
    appMasterKey: "appMasterKey",
    appReadWriteKey: "appReadWriteKey",
    cardProvisionedSuccessfully: "cardProvisionedSuccessfully",
    provisionLoadingMessage: "provisionLoadingMessage",
    keyType: "keyType",
    ossDoorIdOrGroupId: "ossDoorIdOrGroupId",
    standardDesfire: "standardDesfire",
    hidDesfire: "hidDesfire",
    interventionAdmin: "interventionAdmin",
    fileReadError: "fileReadError",
    fileName: "fileName",
    radioActivation: "radioActivation",
    selectAtLeastOneKey: "selectAtLeastOneKey",
    exportingKeysPleaseWait: "exportingKeysPleaseWait",
    keyExportError: "keyExportError",
    keyExportedSuccessfully: "keyExportedSuccessfully",
    keyBackupWarning: "keyBackupWarning",
    importantWithColon: "importantWithColon",
    manufacturer: "manufacturer",
    ossUpdaterReader: "ossUpdaterReader",
    applicationIDHint: "applicationIDHint",
    privilegedAccess: "privilegedAccess",
    permanentLockMode: "permanentLockMode",
    messaging: "messaging",
    lcdMessaging: "lcdMessaging",
    assignBioEventAction: "assignBioEventAction",
    biometricActions: "biometricActions",
    selectEventTypeFirst: "selectEventTypeFirst",
    units: "units",
    weeks: "weeks",
    durationWarningTip: "durationWarningTip",
    daysWithCount: "daysWithCount",
    eventTypeAlreadyExists: "eventTypeAlreadyExists",
    allMessages: "allMessages",
    complianceCondition: "complianceCondition",
    compliance: "compliance",
    operationalCompliance: "operationalCompliance",
    assignedOperationCompliance: "assignedOperationCompliance",
    assignComplianceCondition: "assignComplianceCondition",
    selectComplianceCondition: "selectComplianceCondition",
    operationalComplianceTip: "operationalComplianceTip",
    governedAccessGroup: "governedAccessGroup",
    assignAComplianceCondition: "assignAComplianceCondition",
    lcdActionPreset: "lcdActionPreset",
    expiryReasonsTip: "expiryReasonsTip",
    affectedByExpiry: "affectedByExpiry",
    weeksWithCount: "weeksWithCount",
    monthsWithCount: "monthsWithCount",
    assignedExpiryReasons: "assignedExpiryReasons",
    assignExpiryReason: "assignExpiryReason",
    selectExpiryReason: "selectExpiryReason",
    expiryReasonDetails: "expiryReasonDetails",
    governedAccessGroups: "governedAccessGroups",
    advancedPermissions: "advancedPermissions",
    assignAdvancedPermissions: "assignAdvancedPermissions",
    assignedPermissions: "assignedPermissions",
    eventExpiry: "eventExpiry",
    eventWarning: "eventWarning",
    clickRunReport: "clickRunReport",
    daysWorked: "daysWorked",
    lastUsedDate: "lastUsedDate",
    daysInactive: "daysInactive",
    totalHoursWorked: "totalHoursWorked",
    avgHoursPerDay: "avgHoursPerDay",
    avgFirstInTime: "avgFirstInTime",
    avgLastOutTime: "avgLastOutTime",
    dateOnly: "dateOnly",
    lastOut: "lastOut",
    workingHoursHistory: "workingHoursHistory",
    selectDeviceToTestImage: "selectDeviceToTestImage",
    ossCredentialDeleteWarning: "ossCredentialDeleteWarning",
    ossCredentialSuspendTitle: "ossCredentialSuspendTitle",
    ossCredentialSuspendMessage: "ossCredentialSuspendMessage",
    ossEnrolmentNonCurrentTitle: "ossEnrolmentNonCurrentTitle",
    ossEnrolmentNonCurrentMessage: "ossEnrolmentNonCurrentMessage",
    ossEnrolmentDeleteMessage: "ossEnrolmentDeleteMessage",
    pluginManager: "pluginManager",
    downloads:"downloads",
    downloadsSubtitle: "downloadsSubtitle",
    pluginManagerInstaller:"pluginManagerInstaller",
    downloadWillStartShortly:"downloadWillStartShortly",
    pluginManagerDescription: "pluginManagerDescription",
    apiClientId: "apiClientId",
    apiKey: "apiKey",
    apiClientIdTooltip: "apiClientIdTooltip",
    apiKeyTooltip: "apiKeyTooltip",
    loading: "loading",
    expandedRows: "expandedRows",
    allRows: "allRows",
    activeSite: "activeSite",
    cardsNotUsed: "cardsNotUsed",
    inactiveFor: "inactiveFor",
    inactiveFor30Days : "inactiveFor30Days",
    inactiveFor60Days : "inactiveFor60Days",
    inactiveFor90Days : "inactiveFor90Days",
    inactiveFor180Days : "inactiveFor180Days",
    inactiveFor365Days :"inactiveFor365Days",
    doorAccess: "doorAccess",
    pleaseSelectDoor: "pleaseSelectDoor",
    outcomeTime: "outcomeTime",
    outcomeReader: "outcomeReader",
    result: "result",
    entryDevice: "entryDevice",
    passDevice: "passDevice",
    failDevice: "failDevice",
    passReader: "passReader",
    failReader: "failReader",
    timeoutMinutes: "timeoutMinutes",
    pleaseSelectReader: "pleaseSelectReader",
    entryTestOutcomes: "entryTestOutcomes",
    entryTestOutcomesFilters: "entryTestOutcomesFilters",
    entryTestOutcomesUseCases: "entryTestOutcomesUseCases",
    entryLocation: "entryLocation",
    testDurationSecs: "testDurationSecs",
    doorAccessReport: "doorAccessReport",
    personAccessReport: "personAccessReport",
    pleaseSelectPerson: "pleaseSelectPerson",
    personAccess: "personAccess",
    operationalComplianceReport: "operationalComplianceReport",
    complianceDetails: "complianceDetails",
    compliant: "compliant",
    conditionCount: "conditionCount",
    daysRemaining: "daysRemaining",
    generalAccessReport: "generalAccessReport",
    generalAccess: "generalAccess",
    accessGroupSite: "accessGroupSite",
    waitingForFirstUpdate: "waitingForFirstUpdate",
    pleaseWaitWhileLoading: "pleaseWaitWhileLoading",
    assignEvents: "assignEvents",
    assignBuildings: "assignBuildings",
    assignSites: "assignSites",
}
